import { ChangeDetectorRef, Component, Input } from '@angular/core';

import { EditorView } from 'prosemirror-view';
import { combineLatest, Subject } from 'rxjs';

import { trackByValue } from '@recruitee/common';
import { EditorButton } from '@recruitee/prosemirror';
import { startWith, takeUntil } from 'rxjs/operators';

import { StateUpdated$ } from '../../consts';
import { ToolbarService } from './toolbar.service';

@Component({
  selector: 'pm-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.less'],
})
export class PmToolbarComponent {
  @Input() public editorView: EditorView;
  public ButtonTemplateType: { buttons: EditorButton[]; state: boolean[] };

  public leftOutlet: EditorButton[] = [];
  public rightOutlet: EditorButton[] = [];
  public leftOutletState: boolean[] = [];
  public rightOutletState: boolean[] = [];
  public trackByValue = trackByValue;

  private ngOnDestroy$ = new Subject();

  constructor(
    private toolbarService: ToolbarService,
    private stateUpdated$: StateUpdated$,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    const { leftOutletButtons$, rightOutletButtons$ } = this.toolbarService;
    combineLatest([
      leftOutletButtons$,
      rightOutletButtons$,
      this.stateUpdated$.pipe(startWith(null)),
    ])
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(([left, right]) => {
        const { state } = this.editorView;
        this.leftOutlet = left;
        this.rightOutlet = right;
        this.leftOutletState = left.map(button => button.isActive(state));
        this.rightOutletState = right.map(button => button.isActive(state));
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public onButtonClick(button: EditorButton, origin: HTMLElement) {
    const { state, dispatch } = this.editorView;
    button.run(state, dispatch, origin, false);
  }
}
